import {Dispatch} from "redux";
import {AppError} from "../entity/AppError";
import {resetUserStateBuilder} from "./ResetUserStateAction";

export const evaluateErrorAction = (error: number, dispatch: Dispatch) => {
    if (error === AppError.InvalidToken || error === AppError.ExpiredToken || error === AppError.UNAUTHORIZED) {
        dispatch(resetUserStateBuilder());
    }
}